export default __webpack_public_path__ + "static/media/background.715f7704.png";